import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as bird from '../../images/bird2.png';
import * as bird2 from '../../images/bird3.png';
import * as bird3 from '../../images/bird4.png';
import * as bird4 from '../../images/bird1.png';

const Menu = styled.div`
`;

const Li = styled.div`
  display: flex;
  align-items: center;
  line-height: 18px;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding-top: 20px;
  
  &:first-of-type {
    @media (min-width: 769px) {
        padding-top: 50px;
    }
  }

  @media(min-width: 769px) {
    margin-bottom: 30px;
  }
  
  a {
    color: ${({ theme }) => theme.colors.secondary };
    display: block;
  }
`;

const Bird = styled.img`
  margin: 0 auto;
  display: block;
`;

const Icon = styled.div`
  width: 150px;
  text-align: center;
`;

const MobileMenu = ({ handleMobileMenu, handleMobileClick, handleFolioClick, navAbout, navProcess, navContact,
                      showMobile, navFolio, handleHomeClick }) => {
  return (
      <div>
        <span className="mobile-title" onClick={ handleHomeClick }>Chevo Studios</span>
        <span className="mobile-menu" onClick={ handleMobileMenu }>
          <svg fill="#ab3029" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
          </svg>
        </span>
        { showMobile &&
        <Menu className="mobile-menu__menu">
            <Li>
              <Icon>
                <Bird width="90" height="70" src={ bird } onClick={(e) => { handleFolioClick(e); navFolio() } } alt="Explore" />
              </Icon>
              <a onClick={(e) => { handleFolioClick(e); navFolio() } }>Explore Our Work</a></Li>
            <Li>
              <Icon>
                <Bird width="68" height="70" src={ bird2 } onClick={() => { handleMobileClick(); navAbout() } } alt="Inside Chevo" />
              </Icon>
              <a style={ { marginTop: 0 } } onClick={() => { handleMobileClick(); navAbout() } }>Inside Chevo Studios</a>
            </Li>
            <Li>
                <Icon>
                  <Bird width="66" height="70" src={ bird3 } onClick={() => { handleMobileClick(); navProcess() } } alt="The Way We Work" />
                </Icon>
                <a onClick={() => { handleMobileClick(); navProcess() } }>The Way We Work</a></Li>
            <Li>
              <Icon>
                <Bird width="90" height="55" src={ bird4 } onClick={(e) => { handleFolioClick(e); navContact() } } alt="Get in Touch" />
              </Icon>
              <a onClick={(e) => { handleFolioClick(e); navContact() } }>Get in touch</a></Li>
        </Menu> }
      </div>)
};

MobileMenu.propTypes = {
  handleMobileMenu: PropTypes.func.isRequired,
  handleMobileClick: PropTypes.func.isRequired,
  handleFolioClick: PropTypes.func.isRequired,
  navAbout: PropTypes.func.isRequired,
  navFolio: PropTypes.func.isRequired,
  navProcess: PropTypes.func.isRequired,
  navContact: PropTypes.func.isRequired,
  showMobile: PropTypes.bool.isRequired,
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu/MobileMenu.js